import { render, staticRenderFns } from "./MainMenuSortDialog.vue?vue&type=template&id=abe5767c&scoped=true&"
import script from "./MainMenuSortDialog.vue?vue&type=script&lang=js&"
export * from "./MainMenuSortDialog.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuSortDialog.vue?vue&type=style&index=0&id=abe5767c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe5767c",
  null
  
)

export default component.exports